import { env } from "~/env"

export const isDarel = env.NEXT_PUBLIC_BRAND_NAME === "gerard-darel"
export const isPablo = env.NEXT_PUBLIC_BRAND_NAME === "pablo"
